// extracted by mini-css-extract-plugin
export default {"cardContainer":"from_mingaku_cardContainer__XlBkc","card":"from_mingaku_card__LXg2l","aiTalkImage":"from_mingaku_aiTalkImage__cDIBy"};